export var ClickType;
(function (ClickType) {
    ClickType[ClickType["touch"] = 0] = "touch";
    ClickType[ClickType["mouseLeft"] = 1] = "mouseLeft";
    ClickType[ClickType["mouseCenter"] = 2] = "mouseCenter";
    ClickType[ClickType["mouseRight"] = 3] = "mouseRight";
})(ClickType || (ClickType = {}));
export var MouseClickType;
(function (MouseClickType) {
    MouseClickType[MouseClickType["left"] = 1] = "left";
    MouseClickType[MouseClickType["center"] = 2] = "center";
    MouseClickType[MouseClickType["right"] = 3] = "right";
})(MouseClickType || (MouseClickType = {}));
//# sourceMappingURL=ObjectEvents.js.map